<template>
  <el-date-picker
    v-model="date"
    type="date"
    format="DD-MM-yyyy"
    placeholder="Created Date"
    class="flex-basis-grow"
  />
</template>

<script>
export default {
  name: 'DateCreated',
  computed: {
    date: {
      get() {
        return this.$store.getters['filters/dateCreated']
      },
      set(value) {
        this.$store.commit('filters/dateCreated', value)
      }
    }
  }
}
</script>
